module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Mono-Bold-bbc6ab7cdc2c8266c2a3fd8f108beafd.otf";